/* svnty-paired.js — THE HERO'S HANGER + PAIRED ITEMS + THE COUNTER PILL (R133 block 1, D3-9, 2026-09-20).
 * 1. THE PILL: mirrors Trade's own slider counter (.slider-counter--current / --total, written by
 *    slider-component on every scroll — Math.round(scrollLeft / itemOffset) + 1) into the "1 | 7" pill over
 *    the picture, so the pill is always the slider's truth (hidden colour slides are already excluded there).
 * 2. THE HANGER opens the PAIRED ITEMS sheet: FLOOR + LOCK (the size sheet's mechanics — Trade's overflow-hidden
 *    on body is THE ONE HOLDER; svnty-header.js turns it into html.svnty-locked), Escape / scrim / X / history
 *    back close it; the current slide's picture is copied to the sheet's top.
 * 3. D5-5 (lane B): THE ROWS ON REQUEST. The door's lists come from sections/svnty-paired-body.liquid (the page's own
 *    all_products budget of 20 had run out before the header, B-01) and WEAR IT WITH's other colours' rows from
 *    sections/svnty-look-rows.liquid (the page renders only the colour on screen, B-15); both are fetched once, at idle or
 *    on the first sign of intent (a hanger or a colour pointed at, focused or pressed), and moved into place. The door
 *    opens at its top (B-10), its picture follows the colour bus (B-11), and the look's end door opens on the palette (B-12). */
(function () {
  'use strict';
  var root = document.querySelector('[data-svnty-paired]');
  var gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  /* ---- 1. the pill ---- */
  function wirePill(sc) {
    var cur = sc.querySelector('.slider-counter--current'), tot = sc.querySelector('.slider-counter--total');
    var pillCur = sc.querySelector('[data-svnty-gal-current]'), pillTot = sc.querySelector('[data-svnty-gal-total]');
    if (!cur || !pillCur) return;
    function sync() { pillCur.textContent = cur.textContent; if (tot && pillTot) pillTot.textContent = tot.textContent; }
    /* THE TRUTH AFTER THE COLOUR FILTER: svnty-colour-gallery.js hides the other colours' slides AFTER Trade's
       slider counted them, so the slider's pages are recounted here (resetPages measures clientWidth > 0)
       whenever the picker changes and once after load; the pill then reads the recount. */
    function recount() {
      try { if (sc.resetPages) sc.resetPages(); if (sc.update) sc.update(); } catch (e) {}
      sync();
    }
    sync();
    setTimeout(recount, 250);
    window.addEventListener('load', function () { setTimeout(recount, 50); });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(recount, 80); }); } catch (e) {}
    }
    document.addEventListener('svnty:gallery:filtered', function () { setTimeout(recount, 20); });
    sc.addEventListener('slideChanged', sync);
    if (typeof MutationObserver === 'function') new MutationObserver(sync).observe(cur, { childList: true, characterData: true, subtree: true });
    if (tot && typeof MutationObserver === 'function') new MutationObserver(sync).observe(tot, { childList: true, characterData: true, subtree: true });
  }
  Array.prototype.forEach.call(gallery.querySelectorAll('slider-component'), wirePill);

  /* ---- 2. the sheet (and THE LOOK's colour switch, which lives on every product page) ---- */
  var panel = root ? root.querySelector('.svnty-paired__panel') : null;
  var hero = root ? root.querySelector('[data-paired-hero]') : null;
  var list = root ? root.querySelector('[data-paired-list]') : document.createElement('div');
  var isOpen = false, lastFocus = null;

  /* ---- 3. the rows on request ---- */
  var slot = root ? root.querySelector('[data-paired-slot]') : null, loadingEl = root ? root.querySelector('[data-paired-loading]') : null;
  var bodyP = null, lookP = null;
  var sectionUrl = function (src, id) { src = src || location.pathname; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + id; };
  var fetchDoc = function (url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  };
  /* the door's lists: one request per page; a failure is forgotten so the next intent retries */
  function ensureBody() {
    if (!slot || slot.__done) return Promise.resolve(!!slot);
    if (bodyP) return bodyP;
    bodyP = fetchDoc(sectionUrl(slot.getAttribute('data-paired-src'), 'svnty-paired-body')).then(function (d) {
      var l = d.querySelector('[data-paired-lists]');
      if (!l) throw new Error('no lists');
      slot.innerHTML = '';
      slot.appendChild(document.importNode(l, true));
      slot.__done = true;
      return true;
    }).catch(function () { bodyP = null; return false; });
    return bodyP;
  }
  /* WEAR IT WITH's other colours: every stub row takes its real row; the colour on screen is shown again after */
  var look = document.querySelector('[data-svnty-wearwith][data-ww-src]');
  function ensureLook() {
    if (!look || !look.querySelector('[data-ww-lazy]')) return Promise.resolve(true);
    if (lookP) return lookP;
    lookP = fetchDoc(sectionUrl(look.getAttribute('data-ww-src'), 'svnty-look-rows')).then(function (d) {
      Array.prototype.forEach.call(look.querySelectorAll('[data-ww-lazy]'), function (stub) {
        var c = stub.getAttribute('data-ww-color');
        var real = Array.prototype.find.call(d.querySelectorAll('[data-ww-color]'), function (r) { return r.getAttribute('data-ww-color') === c && !r.hasAttribute('data-ww-lazy'); });
        if (!real) return;
        var n = document.importNode(real, true);
        n.hidden = true;
        Array.prototype.forEach.call(n.querySelectorAll('link[rel="stylesheet"]'), function (l) { l.parentNode.removeChild(l); });
        stub.parentNode.replaceChild(n, stub);
      });
      return true;
    }).catch(function () { lookP = null; return false; });
    return lookP;
  }
  function idle(fn) { if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 1200); }
  window.addEventListener('load', function () { idle(function () { ensureBody(); ensureLook(); }); });
  /* the first sign of intent starts the fetch early: a hanger for the door, a colour of the buy box or the bar for the look */
  ['pointerover', 'focusin', 'pointerdown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-svnty-hanger]')) ensureBody();
      if (t.closest('.svnty-option--colour, [data-svnty-colour-rail], svnty-pdp-sticky')) ensureLook();
    }, { passive: true, capture: true });
  });

  /* D4-14: a hanger on a grid picture names its media; the door then shows THAT picture and its list */
  var forced = null;
  function currentImage() {
    if (forced && forced.src) return forced.src;
    var active = gallery.querySelector('.product__media-item.is-active img') || gallery.querySelector('.product__media-item:not(.svnty-colour-hidden) img');
    return active ? (active.currentSrc || active.src) : '';
  }
  /* THE COLOUR FOLLOWS THE PICKER (D3-14): the groups are server-rendered; the one matching the selected colour shows.
     THE COLOUR PIPELINE (D4-25): the colour is the bus's (assets/svnty-colour.js get()); the picker is read only when the
     bus is absent */
  function selectedColour() {
    try { if (window.SVNTY && window.SVNTY.colour) { var st = window.SVNTY.colour.get(); if (st && st.colour) return st.colour; } } catch (e) {}
    var f = document.querySelector('.svnty-option--colour input[type=radio]:checked');
    if (f) return f.value;
    var v = document.querySelector('[data-selected-swatch-value], [data-svnty-selected-value]');
    return v ? v.textContent.trim() : '';
  }
  /* THE STRIPE NAME (D8-8, R239): the colour as the page prints it ("Blue stripe"), read from the page's own colour input
     (data-svnty-name, product-variant-options); the value above stays the key every group matches */
  function selectedName() {
    var want = selectedColour(), main = document.getElementById('MainContent') || document;
    var ins = main.querySelectorAll('input[data-svnty-name], option[data-svnty-name]');
    for (var i = 0; i < ins.length; i++) if (ins[i].value === want) return ins[i].getAttribute('data-svnty-name') || want;
    return want;
  }
  /* IN THE PICTURE (D4-10): the photo on screen decides; a photo that holds another SVNTY piece shows that list, any other
     photo shows the colour's group (THE PALETTE once written, the look's group until then) */
  function currentMediaId() {
    if (forced && forced.id) return forced.id;
    var active = gallery.querySelector('.product__media-item.is-active') || gallery.querySelector('.product__media-item:not(.svnty-colour-hidden)');
    var el = active && active.querySelector('[data-media-id]');
    var id = el ? el.getAttribute('data-media-id') : '';
    return id ? id.split('-').pop() : '';
  }
  function showGroup() {
    var want = selectedColour();
    var label = list.querySelector('[data-paired-label]');
    var pics = list.querySelectorAll('[data-picture]');
    var mid = currentMediaId(), picHit = null;
    /* the look's end door asks for the palette itself, whatever picture is on screen (B-12) */
    if (!(forced && forced.palette)) pics.forEach(function (g) { if (g.getAttribute('data-picture') === mid) picHit = g; });
    pics.forEach(function (g) { g.hidden = g !== picHit; });
    var groups = list.querySelectorAll('[data-paired-colour]');
    if (picHit) {
      groups.forEach(function (g) { g.hidden = true; });
      if (label) { label.textContent = label.getAttribute('data-label-picture') || 'In this picture'; label.hidden = false; }
    } else if (groups.length) {
      var hit = null;
      groups.forEach(function (g) { if (g.getAttribute('data-paired-colour') === want) hit = g; });
      if (!hit) hit = groups[0];
      groups.forEach(function (g) { g.hidden = g !== hit; });
      if (label) { label.textContent = (label.getAttribute('data-label-palette') || 'In the palette of') + ' ' + (hit.getAttribute('data-paired-colour-name') || hit.getAttribute('data-paired-colour') || want); label.hidden = false; }
    }
    showLook(want);
  }
  /* THE LOOK (D4-4): WEAR IT WITH follows the same colour with its own lists; a colour whose row is still a stub keeps the
     row on screen until its real row has landed (never an empty rail), then shows it */
  function showLook(want) {
    var ww = document.querySelectorAll('[data-svnty-wearwith] [data-ww-color]');
    if (!ww.length) return;
    var whit = null;
    ww.forEach(function (g) { if (g.getAttribute('data-ww-color') === want) whit = g; });
    if (!whit) whit = ww[0];
    if (whit.hasAttribute('data-ww-lazy')) { ensureLook().then(function (ok) { if (ok && selectedColour() === want) showLook(want); }); return; }
    var changed = whit.hidden;
    ww.forEach(function (g) { g.hidden = g !== whit; });
    if (window.SVNTY && window.SVNTY.rows) setTimeout(window.SVNTY.rows.measure, 30);
    if (window.SVNTY && window.SVNTY.railNav) setTimeout(window.SVNTY.railNav.place, 80);
    if (changed) { try { document.dispatchEvent(new CustomEvent('svnty:look:row', { detail: { colour: whit.getAttribute('data-ww-color') } })); } catch (e) {} }
  }
  /* the lists: shown at once when they are here; else the loading line until they land (retried while the door is open) */
  function load() {
    if (!slot || slot.__done) { if (loadingEl) loadingEl.hidden = true; showGroup(); return; }
    if (loadingEl) loadingEl.hidden = false;
    var label = list.querySelector('[data-paired-label]'); if (label) label.hidden = true;
    var tries = 0;
    (function go() {
      ensureBody().then(function (ok) {
        if (ok) { if (loadingEl) loadingEl.hidden = true; if (isOpen) showGroup(); return; }
        if (isOpen && ++tries < 4) setTimeout(go, 800 * tries);
      });
    })();
  }
  /* the picture of the door: the one on screen, or the colour's first when the bus moved while the door is open */
  function heroTo(src) { if (hero) hero.innerHTML = src ? '<img src="' + String(src).replace(/"/g, '&quot;') + '" alt="">' : ''; }
  function colourFirstImage() {
    var im = gallery.querySelector('.product__media-item:not(.svnty-colour-hidden) img');
    return im ? (im.currentSrc || im.getAttribute('src') || '') : '';
  }
  showGroup(); /* THE LOOK shows the selected colour's list at once; the sheet re-reads it on open */
  /* THE COLOUR PIPELINE: one path, the bus; WEAR IT WITH's row and an open sheet's group follow every colour change */
  document.addEventListener('svnty:colour', function () {
    showGroup();
    if (isOpen) {
      var cap = root && root.querySelector('[data-paired-caption-color]'); if (cap) cap.textContent = selectedName();
      /* THE COLOUR LAW (B-11): the picture follows too, the new colour's first picture once the gallery has regrouped */
      forced = forced && forced.palette ? { palette: true } : null;
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (isOpen) { heroTo(colourFirstImage()); showGroup(); } }); });
    }
  });
  /* D11-5 (image 6: the sheet "restricted from the bottom"): at desktop the sheet measures itself once it stands and on a
     resize; an overshoot past the viewport's bottom comes off its height. The inline height goes with the close. */
  function fitFoot() {
    if (!deskLock() || !isOpen) return;
    root.style.removeProperty('height');
    var over = root.getBoundingClientRect().bottom - window.innerHeight;
    if (over > 0.5) root.style.height = Math.round(root.getBoundingClientRect().height - over) + 'px';
  }
  window.addEventListener('resize', function () { if (isOpen) fitFoot(); }, { passive: true });
  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    panel.style.top = '0px'; /* the whole screen, header included (2026-09-20 04:05) */
    heroTo(currentImage());
    /* every opening starts at the top of the door, whatever the last one was scrolled to (B-10) */
    var body = root.querySelector('.svnty-paired__body'); if (body) body.scrollTop = 0;
    var cap = root.querySelector('[data-paired-caption-color]'); if (cap) cap.textContent = selectedName();
    /* D6-17 THE ONE LOCK: the sheet shows in its closed pose with the lock in ONE style pass (no forced layout before the lock),
       and slides open from the frame after it */
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (isOpen) { root.classList.add('is-open'); fitFoot(); } }); });
    if (!deskLock()) document.body.classList.add('overflow-hidden'); /* D4-32: from 990 px the desktop block holds the page (no claim) */
    load();   /* the photo on screen at this moment decides the list */
    try { history.pushState({ svntySheet: 'paired' }, ''); } catch (e) {}
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
    document.addEventListener('keydown', onKey);
  }
  function close(fromPop) {
    if (!isOpen) return;
    isOpen = false;
    forced = null;
    root.classList.remove('is-open'); root.style.removeProperty('height');
    if (!deskUnlock()) document.body.classList.remove('overflow-hidden'); /* D4-32: the desktop block releases its own hold */
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 260);
    if (!fromPop) { try { if (history.state && history.state.svntySheet === 'paired') history.back(); } catch (e) {} }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onKey(e) { if (e.key === 'Escape') close(false); }
  window.addEventListener('popstate', function () { if (isOpen) close(true); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-paired-close]'), function (el) { el.addEventListener('click', function () { close(false); }); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-svnty-hanger]') : null;
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    var mid = t.getAttribute('data-svnty-hanger-media');
    forced = t.hasAttribute('data-svnty-hanger-palette') ? { palette: true } : null;
    if (mid) {
      var slide = t.closest('.product__media-item') || gallery.querySelector('.product__media-item[data-media-id$="-' + mid + '"]');
      var im = slide ? slide.querySelector('img') : null;
      forced = { id: mid, src: im ? (im.currentSrc || im.getAttribute('src')) : '' };
    }
    open();
  });
  /* ==================================================================== DESK (D4-32, R183, 2026-09-25) BEGIN
     THE DESKTOP PANEL (03:35, image 104): from 990 px the door is a right panel UNDER the headstack (svnty-paired.css).
     The phone and 750 to 989 keep Trade's body class (the lock IS the door: the claim parks the bar, the curtain, the root).
     At desktop none of that machinery runs: the page is held here by html.svnty-pd-lock (the viewport stops scrolling, the
     scrollbar's width comes back as padding so nothing moves sideways), so the headstack never claims and the bar stays where
     it was. Tab is trapped in the panel, Escape (onKey above) closes, focus returns to the hanger that opened it, the slab's
     keyboard focus reveal is kept out of the door, a control in the header closes the door before it opens its own layer,
     and crossing 990 while open closes it. */
  var DESK_MQ = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var deskHeld = false, deskTrigger = null;
  function deskLock() {
    if (!(DESK_MQ && DESK_MQ.matches)) return false;
    var de = document.documentElement;
    var g = window.innerWidth - de.clientWidth;
    de.style.setProperty('--svnty-pd-gutter', (g > 0 && g < 40 ? g : 0) + 'px');
    de.classList.add('svnty-pd-lock');
    deskHeld = true;
    if (deskTrigger && document.contains(deskTrigger)) lastFocus = deskTrigger;
    deskTrigger = null;
    return true;
  }
  function deskUnlock() {
    if (!deskHeld) return false;
    var de = document.documentElement;
    de.classList.remove('svnty-pd-lock');
    de.style.removeProperty('--svnty-pd-gutter');
    deskHeld = false;
    return true;
  }
  function deskFocusables() {
    var all = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(all, function (el) { return el.getAttribute('tabindex') !== '-1' && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; });
  }
  if (root && panel) {
    /* the hanger that opens the door, remembered before the opener runs (WebKit does not focus a clicked button) */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-svnty-hanger]') : null;
      if (t) deskTrigger = t;
    }, true);
    document.addEventListener('keydown', function (e) {
      if (!isOpen || !deskHeld || e.key !== 'Tab') return;
      var f = deskFocusables(), a = document.activeElement;
      if (!f.length) { e.preventDefault(); panel.focus(); return; }
      /* the panel walks its own ring (links included: WebKit's Tab skips links by default and would leave the panel) */
      var i = f.indexOf(a), n = f.length;
      e.preventDefault();
      if (e.shiftKey) f[i <= 0 ? n - 1 : i - 1].focus();
      else f[i < 0 || i === n - 1 ? 0 : i + 1].focus();
    });
    /* the slab reveals the parked bar on keyboard focus inside it; the door lives in the slab, so its focus stays in here */
    root.addEventListener('focusin', function (e) { if (deskHeld) e.stopPropagation(); });
    /* a control in the header (search, bag, a tab's panel) closes the door first; a link simply navigates */
    var slabEl = document.querySelector('.svnty-headstack');
    if (slabEl) slabEl.addEventListener('click', function (e) {
      if (!isOpen || !deskHeld || root.contains(e.target)) return;
      var c = e.target.closest ? e.target.closest('button, summary, [role="button"]') : null;
      if (c && !c.closest('a[href]')) close(false);
    }, true);
    if (DESK_MQ) {
      var onCross = function () { if (isOpen) close(false); };
      if (DESK_MQ.addEventListener) DESK_MQ.addEventListener('change', onCross); else if (DESK_MQ.addListener) DESK_MQ.addListener(onCross);
    }
  }
  /* ==================================================================== DESK (D4-32) END */
  window.SVNTY = window.SVNTY || {};
  window.SVNTY.paired = { open: open, close: close };
})();
